export const ROLES = {
  CUSTOMER: 'CUSTOMER',
  STAFF: 'STAFF',
  MERCHANT: 'MERCHANT',
  AUTO_MESSAGE: 'AUTO_MESSAGE',
} as const

export type Role = keyof typeof ROLES

const staffAndAutoMessageEndpoints = {
  getConversation: '/bm/buyback/v1/staff/orders/:id/messages',
  getMetadata: '/bm/buyback/v1/staff/orders/:id/messages/metadata',
  postMessage: '/bm/buyback/v1/staff/orders/:id/messages',
} as const

export const conversationEndpoints = {
  [ROLES.STAFF]: staffAndAutoMessageEndpoints,
  [ROLES.AUTO_MESSAGE]: staffAndAutoMessageEndpoints,
  [ROLES.MERCHANT]: {
    getConversation: '/bm/buyback/v1/refurbisher/orders/:id/messages',
    getMetadata: '/bm/buyback/v1/refurbisher/orders/:id/messages/metadata',
    postMessage: '/bm/buyback/v1/refurbisher/orders/:id/messages',
  },
  [ROLES.CUSTOMER]: {
    getConversation: '/bm/buyback/v1/customer/orders/:id/messages',
    getMetadata: '/bm/buyback/v1/customer/orders/:id/messages/metadata',
    postMessage: '/bm/buyback/v1/customer/orders/:id/messages',
  },
} as const
